export function isFunc(func) {
    return (typeof func === "function")
}